import { formatPercentage } from './utils';

export const weightTemplate = (taskFromLookahead, t) => {
  if (Number(taskFromLookahead.ponderator) !== 0) {
    return `<span class="vertical-center cost-fix-gantt" style="padding-left: 19;">
                  ${formatPercentage(taskFromLookahead, t('lang'), taskFromLookahead.ponderator)}
          </span>`;
  }
  return formatPercentage(
    taskFromLookahead,
    t('lang'),
    taskFromLookahead.ponderator
  );
};
